import type {AddComponentTypeOptions} from 'grapesjs';
import {asteriskHtml, createBaseBoxComponent} from '@FormMakerReact/components/create-base-box-component';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {POSTERMYWALL_EMAIL_INPUT_TYPE} from '@FormMakerReact/components/postermywall-email-input/postermywall-email-input';

export const POSTERMYWALL_EMAIL_BOX_TYPE = 'postermywall-email-box';

export const POSTERMYWALL_EMAIL_BOX: AddComponentTypeOptions = createBaseBoxComponent({
  boxType: POSTERMYWALL_EMAIL_BOX_TYPE,
  dataMarkerAttribute: 'data-is-pmw-form-email-box',
  components: [{type: POSTERMYWALL_FORM_TEXT_TYPE, content: `<strong>Email${asteriskHtml(true)}</strong>`}, {type: POSTERMYWALL_EMAIL_INPUT_TYPE}],
});
